<template>
  <div class="projetos-container">
    <h2 class="titulo-principal">Projetos Realizados</h2>
    <h3>Conheça alguns dos nossos projetos de sucesso que mostram nosso comprometimento com qualidade e resultados</h3>

    <div class="secao-projetos">
      <!-- Projeto 1 -->
      <div class="projeto-box fade-in">
        <h3 class="titulo-projeto">Climatização de Armazém Industrial</h3>
        <p class="descricao-projeto">
          Instalação de sistemas de ar condicionado para refrigeração de cargas sensíveis.
        </p>
        <div class="imagens-paralelas">
          <div class="imagem-quadro">
            <img src="@/assets/armazem1.jpg" alt="Sistema de climatização em armazém 1" />
          </div>
          <div class="imagem-quadro">
            <img src="@/assets/armazem2.jpg" alt="Sistema de climatização em armazém 2" />
          </div>
        </div>
      </div>

      <!-- Projeto 2 -->
      <div class="projeto-box fade-in">
        <h3 class="titulo-projeto">Portas Automáticas Comerciais</h3>
        <p class="descricao-projeto">
          Automação de portas de entrada com sensores de movimento e controle remoto.
        </p>
        <div class="imagens-paralelas">
          <div class="imagem-quadro">
            <img src="@/assets/porta.jpg" alt="Porta automática comercial 1" />
          </div>
          <div class="imagem-quadro">
            <img src="@/assets/porta1.jpg" alt="Porta automática comercial 2" />
          </div>
        </div>
      </div>

      <!-- Projeto 3 -->
      <div class="projeto-box fade-in">
        <h3 class="titulo-projeto">Sistema de Automação para Linha de Produção</h3>
        <p class="descricao-projeto">
          Controle de processos industriais com PLCs e sensores para maior eficiência.
        </p>
        <div class="imagens-paralelas">
          <div class="imagem-quadro">
            <img src="@/assets/compacta.jpg" alt="Automação linha de produção - compacta" />
          </div>
          <div class="imagem-quadro">
            <img src="@/assets/esteira.jpg" alt="Automação linha de produção - esteira" />
          </div>
        </div>
      </div>
    </div>
    <section class="gallery-section zoom-in">
      <div class="gallery">
        <img src="@/assets/reparados.jpg" alt="Instalação de ar-condicionado industrial" />
        <img src="@/assets/vent.jpg" alt="Reparação de ventilador" />
        <img src="@/assets/sistema.jpg" alt="Serviços de manutenção em máquina industrial" />
        <img src="@/assets/images/ffjb023.jpg" alt="Manutenção de máquina compactadora" />
        <img src="@/assets/images/ffjb024.jpg" alt="Reparação de sistema de água industrial" />
        <img src="@/assets/images/ffjb025.jpg" alt="Reparação de sistema eletrico industrial" />
        <img src="@/assets/images/prensa.jpg" alt="Manutenção de máquina compactadora" />
        <img src="@/assets/images/motores.jpg" alt="Reparação de sistema de água industrial" />
        <img src="@/assets/images/eletrica.jpg" alt="Reparação de sistema eletrico industrial" />
        <img src="@/assets/images/ffjb02.jpg" alt="Instalação de ar-condicionado industrial" />
        <img src="@/assets/images/ffjb021.jpg" alt="Reparação de ventilador" />
        <img src="@/assets/images/ffjb022.jpg" alt="Serviços de manutenção em máquina industrial" />
      </div>
    </section>

    <!-- Seção Antes e Depois -->
    <div class="secao-projetos">
      <h3 class="titulo-principal">Galeria Antes/Depois</h3>

      <!-- Climatização -->
      <div class="projeto-box fade-in">
        <p class="descricao-projeto"><strong>Antes e depois da instalação de climatização no armazém</strong></p>
        <div class="imagens-paralelas">
          <div class="imagem-quadro">
            <img src="@/assets/escritorio.jpg" alt="Antes da climatização do escritório" />
            <p class="legenda">Antes</p>
          </div>
          <div class="imagem-quadro">
            <img src="@/assets/escritorio1.jpg" alt="Depois da climatização do escritório" />
            <p class="legenda">Depois</p>
          </div>
        </div>
      </div>

      <!-- Portas Automáticas -->
      <div class="projeto-box fade-in">
        <p class="descricao-projeto"><strong>Transformação das portas automáticas comerciais</strong></p>
        <div class="imagens-paralelas">
          <div class="imagem-quadro">
            <img src="@/assets/entrada.jpg" alt="Antes das portas automáticas" />
            <p class="legenda">Antes</p>
          </div>
          <div class="imagem-quadro">
            <img src="@/assets/entrada1.jpg" alt="Depois das portas automáticas" />
            <p class="legenda">Depois</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProjetosPage",
};
</script>

<style scoped>
/* Estilo geral da página */
.projetos-container {
  max-width: 1200px;
  color: #ffffff;
  margin: 0 auto;
  padding: 40px 20px;
  background-color: #000000;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.titulo-principal {
  text-align: center;
  font-size: 2.2rem;
  margin-bottom: 40px;
  color: #ffffff;
}

.secao-projetos {
  margin-bottom: 60px;
}

h3 {
text-align: center;
}


/* Cartão de projeto */
.projeto-box {
  background: linear-gradient(135deg, #000000, #000000);
  border-radius: 16px;
  padding: 30px;
  margin-bottom: 40px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.projeto-box:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
}

.titulo-projeto {
  text-align: center;
  font-size: 1.6rem;
  margin-bottom: 15px;
  color: #f1f1f1;
}

.descricao-projeto {
  text-align: center;
  font-size: 1rem;
  margin-bottom: 25px;
  color: #ffffff;
}

/* Gallery */
.gallery-section {
  padding: 40px 20px;
  background: linear-gradient(135deg, #000000, #000000);
  text-align: center;
}

.gallery {
    color: #ffffff;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
}

.gallery img {
  color: #ffffff;
  width: 100%;
  max-width: 300px;
  border-radius: 10px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
}

.gallery img:hover {
  transform: scale(1.05);
}
/* Layout de imagens */
.imagens-paralelas {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
}

.imagem-quadro {
  flex: 1 1 45%;
  max-width: 400px;
  border-radius: 10px;
  overflow: hidden;
  background-color: #050505;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.imagem-quadro img {
  width: 100%;
  height: 500px;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.imagem-quadro:hover img {
  transform: scale(1.05);
}

.legenda {
  
  text-align: center;
  font-size: 0.875rem;
  padding: 8px;
  background-color: #000000;
  color: #ffffff;
}

/* Animações */
.fade-in {
  opacity: 0;
  transform: translateY(30px);
  animation: fadeInUp 1s ease forwards;
}

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsividade */
@media (max-width: 768px) {
  .imagem-quadro {
    flex: 1 1 100%;
  }

  .titulo-principal {
    font-size: 1.8rem;
  }

  .titulo-projeto {
    font-size: 1.4rem;
  }
}

@media (max-width: 480px) {
  .descricao-projeto {
    font-size: 0.95rem;
  }

  .projeto-box {
    padding: 20px;
  }
}
</style>
